module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Temperature-empty-6e89107b8d07d19784d3d8e66fba6ad4.svg";